import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sbFilterCount',
    standalone: true
})
export class SbFilterCountPipe implements PipeTransform {
    transform(
        selectedOptions: Array<any>,
        availableOptions: Array<any>,
        isLoading?: boolean
    ): number {
        return isLoading ? 0 : selectedOptions?.length < availableOptions?.length ? 1 : 0;
    }
}
